import { Stack, Typography } from "@mui/material";
import UserWithAvatar from "@entrilia/shared/components/UserWithAvatar";

interface Props {
  userName: string;
  email: string;
  isCurrentUser?: boolean;
}

const ManagedMemberDetails = ({ userName, email, isCurrentUser }: Props) =>
  isCurrentUser ? (
    <Stack direction="row" spacing={3} sx={{ alignItems: "center", width: "100%" }}>
      <UserWithAvatar userName={userName} userNameVariant="subtitle2" email={email} />
      <Typography>(me)</Typography>
    </Stack>
  ) : (
    <UserWithAvatar userName={userName} userNameVariant="subtitle2" email={email} />
  );

export default ManagedMemberDetails;
